import React, { Component } from 'react';
import type Node from 'react';
import { withRouter } from 'react-router-dom';
import { camelizeKeys } from 'humps';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import Loading from '../Loading';

type Props = {
  trek: Object,
  invoiceId: string,
  children: Node,
  match: {
    params: {
      invoiceId: string,
    },
  },
};

/**
 *  This component is used to fetch invoice data.
 *  The invoiceId is taken from the url via react-router's params and
 *  is used for fetching the invoice data.
 */

class InjectInvoiceData extends Component<Props> {
  state = {
    invoices: null,
  };

  componentDidMount() {
    this.fetchInvoices();
  }

  async fetchInvoices() {
    try {
      const { invoiceId } = this.props.match.params;
      const { data: invoices } = await api.get(endpoints.payment.getInvoice(invoiceId));

      this.setState(() => ({
        invoices,
      }));
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const { invoices } = this.state;
    const {
      match: {
        params: { invoiceId },
      },
      children,
    } = this.props;

    if (!invoices) return <Loading />;

    return children({
      invoice: camelizeKeys(invoices.invoice),
      lineItems: camelizeKeys(invoices.line_items),
      invoiceId: invoiceId,
    });
  }
}

export default withRouter(InjectInvoiceData);



// WEBPACK FOOTER //
// ./src/components/InjectInvoiceData/InjectInvoiceData.js